module.exports = __webpack_public_path__ + "static/addcommit-322500ba871070f73cb12c70bb8dc701.png";